export default __webpack_public_path__ + "6c95db4951199b1fd051c589a6dbb9d4.png";